// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
import AwFileUpload from 'viewmodel/AwFileUploadViewModel';
import AwBreak from 'viewmodel/AwBreakViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/thumbnailFileUploadService', () => import('js/thumbnailFileUploadService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "lifecycleHooks": {
        "onUpdate": {
            "observers": [
                "props.accsessionid"
            ]
        }
    },
    "data": {
        "filesForLibrary": {
            "displayName": "{{i18n.filesForLibrary}}",
            "type": "STRING"
        },
        "isThumbnailSelected": false,
        "setCreateStagingAreaFlag": false
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        },
        "libraryid": {
            "type": "string"
        }
    },
    "actions": {
        "uploadFileToServer": {
            "actionType": "JSFunctionAsync",
            "method": "uploadCatalogFilestoDss",
            "inputData": {
                "accsessionid": "{{props.accsessionid}}",
                "filesAddedUploadTickets": "{{data.filesAddedInStagingArea.output.data.results}}",
                "formData": "{{data.fileInputForms}}",
                "fileType": "{{data.fileType}}",
                "accUrl": "{{data.accUrl}}"
            },
            "events": {
                "success": [
                    {
                        "name": "uploadfilesuccess"
                    }
                ]
            },
            "deps": "js/thumbnailFileUploadService"
        },
        "createStagingArea": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}",
                            "containerId": "{{props.libraryid}}",
                            "containerType": "library"
                        },
                        "query": "mutation createStagingArea( $createStagingAreaInput: CreateStagingAreaInput) { createStagingArea( createStagingAreaInput: $createStagingAreaInput ) }",
                        "variables": {
                            "createStagingAreaInput": {
                                "parentFolderId": "",
                                "stagingAreaType": "BMECat"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "createStagingArea": "data.data.createStagingArea"
            },
            "events": {
                "failure": [
                    {
                        "name": "desCreateStagingAreaFailure",
                        "eventData": {
                            "eventData": "{{response}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "desCreateStagingAreaSuccess",
                        "eventData": {
                            "eventData": "{{response}}"
                        }
                    }
                ]
            },
            "actionMessages": {},
            "deps": "js/accHttpService"
        },
        "AddFilesToStagingArea": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}",
                            "containerId": "{{props.libraryid}}",
                            "containerType": "library",
                            "stagingAreaId": "{{data.createStagingArea.output.data.stagingAreaId}}"
                        },
                        "query": "mutation addFilesToStagingArea( $addFilesToStagingAreaInput: AddFilesToStagingAreaInput) { addFilesToStagingArea( addFilesToStagingAreaInput: $addFilesToStagingAreaInput ) }",
                        "variables": {
                            "addFilesToStagingAreaInput": {
                                "fileList": "{{data.inputForAddFilesToStagingArea}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "filesAddedInStagingArea": "data.data.addFilesToStagingArea",
                "accUrl": "data.data.addFilesToStagingArea.accUrl"
            },
            "events": {
                "failure": [
                    {
                        "name": "desaddFilesToStagingAreaFailure",
                        "eventData": {
                            "eventData": "{{filesAddedInStagingArea}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "desaddFilesToStagingAreaSuccess",
                        "eventData": {
                            "eventData": "{{filesAddedInStagingArea}}"
                        }
                    }
                ]
            },
            "actionMessages": {},
            "deps": "js/accHttpService"
        },
        "perfromImport": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {},
                        "query": "mutation performImport ( $collaborationspaceId: String, $containerType: String, $containerId: String, $stagingAreaId: String ) { performImport( collaborationspaceId: $collaborationspaceId, containerType: $containerType,containerId: $containerId, stagingAreaId: $stagingAreaId)}",
                        "variables": {
                            "collaborationspaceId": "{{props.collaborationspaceid}}",
                            "containerId": "{{props.libraryid}}",
                            "containerType": "library",
                            "stagingAreaId": "{{data.createStagingArea.output.data.stagingAreaId}}"
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "performImport": "data.data.performImport"
            },
            "events": {
                "failure": [
                    {
                        "name": "desperfromImportFailure",
                        "eventData": {
                            "eventData": "{{performImport}}"
                        },
                        "condition": "conditions.performImportCondition"
                    }
                ],
                "success": [
                    {
                        "name": "desperfromImportSuccess",
                        "eventData": {
                            "eventData": "{{performImport}}"
                        },
                        "condition": "conditions.performImportCondition"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "uploadFilesInStagingAreaAction": {
            "actionType": "JSFunction",
            "method": "getSelectedFilesInfo",
            "inputData": {
                "fileName": "{{parameters.fileName}}",
                "formData": "{{parameters.formData}}",
                "parameters": "{{parameters}}"
            },
            "outputData": {
                "fileInputForms": "fileInputForms",
                "fileNames": "fileNames",
                "isFileValid": "isFileValid",
                "fileType": "fileType",
                "inputForAddFilesToStagingArea": "inputForAddFilesToStagingArea"
            },
            "events": {
                "success": [
                    {
                        "name": "fileSelectionSuccess",
                        "eventData": {
                            "eventData": "{{isFileValid}}"
                        }
                    }
                ]
            },
            "deps": "js/thumbnailFileUploadService"
        },
        "perfromBatchActionForSupplierPerfromImport": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "createStagingArea"
                },
                {
                    "action": "AddFilesToStagingArea"
                },
                {
                    "action": "uploadFileToServer"
                },
                {
                    "action": "perfromImport"
                }
            ]
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        }
    },
    "onEvent": [
        {
            "eventId": "invalidFileSelected",
            "message": "invalidFileError"
        },
        {
            "eventId": "desperfromImportSuccess",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "desperfromImportSuccess",
                "eventData": "{{eventData}}"
            }
        },
        {
            "eventId": "desperfromImportFailure",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "desperfromImportFailure",
                "eventData": "{{eventData}}"
            }
        }
    ],
    "messages": {
        "invalidFileError": {
            "messageType": "WARNING",
            "messageText": "{{i18n.invalidFileError}}",
            "navigationOptions": [
                {
                    "option": "Cancel",
                    "text": "{{i18n.CancelText}}"
                }
            ]
        }
    },
    "conditions": {
        "enablePerfromImportButton": {
            "expression": "data.fileInputForms.length > 0"
        },
        "displaySupplierFileUpload": {
            "expression": "props.isSupplier === 'true'"
        },
        "performImportCondition": {
            "expression": "performImport.output.success"
        }
    },
    "i18n": {
        "invalidFileError": [
            "DesLibraryMessages"
        ],
        "fileUploadSuccess": [
            "DesLibraryMessages"
        ],
        "filesForLibrary": [
            "DesLibraryMessages"
        ],
        "removeFileBtnTooltip": [
            "DesLibraryMessages"
        ],
        "perfromImport": [
            "DesLibraryMessages"
        ],
        "createStagingArea": [
            "DesLibraryMessages"
        ],
        "addFilesToStagingArea": [
            "DesLibraryMessages"
        ],
        "catalogInfo": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesUploadSupplierContentInLibrary",
    "_uniqueViewModelId": "DesUploadSupplierContentInLibrary",
    "ctx": {}
};

    /*
    <aw-panel>



    <aw-panel-body>
        <!-- files are added recursively with folder -->
        <aw-label prop="data.filesForLibrary"></aw-label>
        <aw-file-upload file-change-action="uploadFilesInStagingAreaAction" multiple="{{true}}"
            remove-tooltip="{{i18n.removeFileBtnTooltip}}">
        </aw-file-upload>
    </aw-panel-body>
    <aw-break></aw-break>

    <aw-panel-footer>
        <aw-button class='small' button-type='accent-high-contrast' size='stretched'
            action='perfromBatchActionForSupplierPerfromImport'>{{i18n.perfromImport}}
        </aw-button>
    </aw-panel-footer>
</aw-panel>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}>
        <AwPanelBody>
            <AwLabel {...getField("data.filesForLibrary", fields, $index, null, null )}>
            </AwLabel>
            <AwFileUpload dndHandler={props.viewModel.dndHandler} fileChangeAction={actions.uploadFilesInStagingAreaAction} multiple={AwParseService.instance( "true" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} removeTooltip={AwParseService.instance( "i18n.removeFileBtnTooltip" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            </AwFileUpload>
        </AwPanelBody>
        <AwBreak>
        </AwBreak>
        <AwPanelFooter>
            <AwButton className="small" buttonType="accent-high-contrast" size="stretched" action={actions.perfromBatchActionForSupplierPerfromImport}>
                {AwParseService.instance( "i18n.perfromImport" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
            </AwButton>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;